export default "__VITE_ASSET__DDNbIJ1l__"